import type { GroupedTask, MinifiedTask } from '@gcv/shared';

import { isGroupedTask } from '../../tasks/tasks.model';

/** Drops a deleted task from a cached list, emptying out any group it leaves behind. */
export const getTasksWithoutTask = <T extends MinifiedTask | GroupedTask>(tasks: T[], taskId: string): T[] =>
  tasks
    .map((task) =>
      isGroupedTask(task) ? { ...task, tasks: task.tasks.filter((subtask) => subtask.id !== taskId) } : task
    )
    .filter((task) => (isGroupedTask(task) ? task.tasks.length > 0 : task.id !== taskId)) as T[];
